export default "__VITE_ASSET__DK755xFF__"